import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { DriverSiteSetting } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type DriverSiteSettingModel = getEntityType<DriverSiteState>;

export type DriverSiteState = EntityState<RequireSome<Partial<DriverSiteSetting>, 'id'>>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'driver-site' })
export class DriverSiteStore extends EntityStore<DriverSiteState> {
  constructor() {
    super({});
  }
}
